module.exports = __webpack_public_path__ + "static/img/home-1.8f3e7034.png";